<template>
  <li class="col-span-1 flex flex-col bg-white border border-neutral-200 rounded-lg hover:shadow-xl hover:bg-neutral-50 transition duration-250 relative overflow-hidden">
    <a
      :href="url"
      class="flex flex-col cursor-pointer h-full group"
    >
      <div class="py-4 flex flex-col justify-start text-left">
        <div class="flex px-4 flex-col justify-start">
          <div class="flex space-x-4">
            <div class="w-12 h-12 md:w-20 md:h-20 rounded-full overflow-hidden shrink-0 bg-neutral-300 flex items-center justify-center">
              <img
                v-if="partner.uri_photo"
                class="w-12 h-12 md:w-20 md:h-20"
                :data-src="partner.uri_photo"
                :alt="partner.first_name"
              />
              <fa
                v-else
                class="fa-fw text-5xl text-neutral-400"
                :icon="['fal', 'user-md']"
              />
            </div>
            <div class="flex flex-col items-start justify-center">
              <h3 class="font-semibold group-hover:underline transition text-ocean-950">
                {{ fullName }}
              </h3>
              <dl class="flex flex-col tems-center">
                <dt class="sr-only">{{ $t('app.capabilities') }}</dt>
                <dd class="text-sm transition">
                  <span>{{ fullDesignation }}</span>
                </dd>
              </dl>
              <div
                class="flex mt-1.5"
                :class="fullReview ? 'flex-col justify-start items-start' : 'justify-between items-center'"
              >
                <div
                  v-if="!partner.rating_count > 0"
                  class="flex flex-row items-center justify-center space-x-1 shrink-0 text-sm"
                >
                  <div class="flex items-center space-x-0.5">
                    <fa
                      :icon="['fas', 'star']"
                      class="fa-fw text-bubblegum"
                    />
                    <span class="font-semibold text-bubblegum">{{ partner.rating_average }}</span>
                  </div>
                  <span>&middot;</span>
                  <span>{{ partner.rating_count }} {{ $tc('quote.review', partner.rating_count) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-1">
        <dl
          v-if="partner.description && !hideDescription"
          class="mb-4"
        >
          <dt class="sr-only">{{ $t('app.description') }}</dt>
          <dd class="text-sm leading-5 text-neutral-600 sm:col-span-2 vetster-prose line-clamp-3 px-4 text-left group-hover:text-ocean-700">
            {{ partner.description }}
          </dd>
        </dl>
      </div>
      <div
        class="flex"
        :class="fullReview ? 'flex-col justify-start items-start' : 'justify-between items-center'"
      >
        <div class="w-full flex flex-row items-center justify-end space-x-1 py-2 px-2 text-ocean-900 bg-ocean-50">
          <span class="text-sm">{{ $t('app.from') }}</span>
          <span class="text-lg font-bold flex items-center">
            <span>
              {{ $n(formatMoneyRounded(partner.starting_rate), {
                style: 'currency',
                currency: partner.rate_currency,
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
              }) }}
            </span>
            <fa
              :icon="['fal', 'angle-right']"
              class="text-xl fa-fw"
            />
          </span>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
import { formatMoneyRounded } from '@/helpers/format';
import LocalizesRoutes from '@/mixins/LocalizesRoutes';
import User from '@/models/User';

export default {
  name: 'VetsterDynamicCityTile',

  mixins: [LocalizesRoutes],

  props: {
    fullReview: {
      type: Boolean,
      default: false,
    },
    hideDescription: {
      type: Boolean,
      default: false,
    },
    partner: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      user: new User(this.partner),
    };
  },

  computed: {
    fullName() {
      return this.user?.fullNameWithTitle();
    },
    fullDesignation() {
      return this.user?.fullDesignation();
    },
    url() {
      return this.localizeUrl(`p/${this.partner.uri_slug}?search_result_uuid=${this.partner.search_result_uuid}`);
    },
  },

  methods: {
    formatMoneyRounded,
  },
};
</script>
